/**
 * This function strips out any properties specified by `propertiesToDelete` from a nested structure.
 * If no `propertiesToDelete` are specified, it will by default remove any `uiProperties` properties.
 * @param {object} objToSerialize
 * @param {string[]} [propertiesToDelete]
 * @returns object
 */
export const defaultSerializer = (objToSerialize, propertiesToDelete = ['uiProperties']) => {
  if (typeof objToSerialize !== 'object' || objToSerialize === null) {
    return objToSerialize;
  }

  if (Array.isArray(objToSerialize)) {
    return objToSerialize.map((item) => defaultSerializer(item, propertiesToDelete));
  }

  propertiesToDelete.forEach((prop) => {
    delete objToSerialize[prop];
  });

  Object.values(objToSerialize).forEach((maybeObjectValue) => {
    if (typeof maybeObjectValue === 'object' && maybeObjectValue !== null) {
      defaultSerializer(maybeObjectValue, propertiesToDelete);
    }
  });

  return objToSerialize;
};
